module.exports = __webpack_public_path__ + "static/media/logotipo_hands_branco.daf97d7b.svg";